export const BUSINESS_WHATSAPP_NUMBER = '919602947279';

/** Normalizes a visitor-entered Indian number without accepting an invalid contact. */
export function normalizeIndianPhone(value: string): string | null {
  let digits = value.replace(/[^\d]/g, '');
  if (digits.length === 12 && digits.startsWith('91')) digits = digits.slice(2);
  return /^[6-9]\d{9}$/.test(digits) ? digits : null;
}

export function formatIndianPhone(value: string): string {
  const normalized = normalizeIndianPhone(value);
  return normalized ? `+91 ${normalized}` : value;
}

/** Builds a user-initiated WhatsApp deep link; this only pre-fills a message, it does not send it. */
export function buildWhatsAppUrl(message: string): string {
  const configuredNumber = BUSINESS_WHATSAPP_NUMBER.replace(/\D/g, '');
  const internationalNumber =
    configuredNumber.length === 12 && configuredNumber.startsWith('91')
      ? configuredNumber
      : `91${configuredNumber}`;
  return `https://wa.me/${internationalNumber}?text=${encodeURIComponent(message)}`;
}

/** A short display-only reference for the customer’s WhatsApp request; it is not a booking ID. */
export function createReferenceId(randomValue = Math.random()): string {
  const fourDigits = Math.floor(Math.abs(randomValue) * 10_000) % 10_000;
  return `LS-${String(fourDigits).padStart(4, '0')}`;
}
